function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/intro', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));

export const intro = {
    title: 'Dak Galbi (Stir Fry Spicy Chicken)',
    description: 'Spicy chicken marinated with gochujang & stir fried with carrots, rice cakes, potatoes and onions',
    prepTime: 45,
    cookTime: 20,
    totalTime: 65,
    media: allMedia,
    storySummary: `This Korean spicy <i>Dak Galbi</i> is sweet, spicy, tangy and umami (flavor explosion)! The sauce is made from gochujang but the secret ingredient is a little bit of curry powder.`,
    storyMore: `<p>If you’re not lactose, add a little cheese and it will make the chicken less spicy. I highly recommend eating with some lettuce wraps as well. Don’t forget to leave some dak galbi leftovers to make a spicy fried rice at the end.</p>`,
    keywords: ['cheese', 'chicken', 'dak galbi', 'korean', 'spicy'],
    recipeCategory: ['dinner'],
    cuisine: ['Korean'],
    id: 'dak-galbi',
    author: 'Restaurant name'
}